import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import moment from 'moment';
import React from 'react';
export function formatDate(date) {
  var dd = date.getUTCDate();
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = date.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}
var convertTo12Hour = function convertTo12Hour(timeStr) {
  if (!timeStr) return;
  var _timeStr$split = timeStr.split(':'),
    _timeStr$split2 = _slicedToArray(_timeStr$split, 2),
    hourStr = _timeStr$split2[0],
    minute = _timeStr$split2[1];
  var hour = parseInt(hourStr, 10);
  var period = hour >= 12 ? 'pm' : 'am';
  hour = hour % 12 || 12; // Convert 0 to 12 for midnight
  return "".concat(hour, ":").concat(minute).concat(period);
};
export function formatPrettyDate(date) {
  var _parts$find, _parts$find2, _parts$find3, _parts$find4;
  var rawDateStr = date.date ? date.date : date.event_date;
  var newDate;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(rawDateStr)) {
    var _rawDateStr$split$map = rawDateStr.split('/').map(Number),
      _rawDateStr$split$map2 = _slicedToArray(_rawDateStr$split$map, 3),
      d = _rawDateStr$split$map2[0],
      m = _rawDateStr$split$map2[1],
      y = _rawDateStr$split$map2[2];
    newDate = new Date(Date.UTC(y, m - 1, d, 12, 0, 0)); // noon UTC prevents day shifting
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(rawDateStr)) {
    var _rawDateStr$split$map3 = rawDateStr.split('-').map(Number),
      _rawDateStr$split$map4 = _slicedToArray(_rawDateStr$split$map3, 3),
      _y = _rawDateStr$split$map4[0],
      _m = _rawDateStr$split$map4[1],
      _d = _rawDateStr$split$map4[2];
    newDate = new Date(Date.UTC(_y, _m - 1, _d, 12, 0, 0));
  } else {
    newDate = new Date(rawDateStr);
  }
  var options = {
    timeZone: 'America/New_York',
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };

  // Build localized strings in NY time
  var formatter = new Intl.DateTimeFormat('en-US', options);
  var parts = formatter.formatToParts(newDate);
  var dayName = ((_parts$find = parts.find(function (p) {
    return p.type === 'weekday';
  })) === null || _parts$find === void 0 ? void 0 : _parts$find.value) || '';
  var monthName = ((_parts$find2 = parts.find(function (p) {
    return p.type === 'month';
  })) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value) || '';
  var dayNum = ((_parts$find3 = parts.find(function (p) {
    return p.type === 'day';
  })) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value) || '';
  var year = ((_parts$find4 = parts.find(function (p) {
    return p.type === 'year';
  })) === null || _parts$find4 === void 0 ? void 0 : _parts$find4.value) || '';

  // Build the time range using NY timezone too
  var startTime = convertTo12Hour(date.start_time, 'America/New_York');
  var endTime = date.end_time ? convertTo12Hour(date.end_time, 'America/New_York') : '';
  return /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'Bebas Neue'
    }
  }, "".concat(dayName, " | ").concat(startTime).concat(endTime ? ' - ' + endTime : ''));
}
export var objectToFormData = function objectToFormData(obj, form, namespace) {
  var fd = form || new FormData();
  var formKey;
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }
      // if the property is an object, but not a File,
      // use recursivity.
      if (_typeof(obj[property]) === 'object' && !(obj[property] instanceof File)) {
        objectToFormData(obj[property], fd, property);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }
  return fd;
};
export function htmlEncodeInputDisplay(string) {
  if (string == null || jQuery.trim(string) == "") return string;
  string = string.replace(/&lt;/g, "<");
  string = string.replace(/&gt;/g, ">");
  string = string.replace(/&amp;/g, "&");
  string = string.replace(/&nbsp;/g, " ");
  string = string.replace(/\"/g, "&quot;");
  string = string.replace(/&#8221;/g, '"');
  string = string.replace(/&#8220;/g, '"');
  string = string.replace(/&#8211;/g, '-');
  return string;
}
export function fetchEvents(param, event_type) {
  var data = {
    action: 'do_ajax',
    fn: 'get_events',
    dataType: 'json',
    param: param,
    event_type: event_type
  };
  return axios.post(ajaxurl, objectToFormData(data)).then(function (results) {
    return results.data;
  })["catch"](function (error) {
    return error;
  });
}
export function fetchAllEvents() {
  return _fetchAllEvents.apply(this, arguments);
}
function _fetchAllEvents() {
  _fetchAllEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fn, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fn = nycjwEventSettings.selected_term ? 'get_events_by_term' : 'get_all_events';
          data = {
            action: 'do_ajax',
            fn: fn,
            dataType: 'json'
          };
          if (nycjwEventSettings.selected_term) {
            data.term = nycjwEventSettings.selected_term;
          }
          return _context.abrupt("return", axios.post(ajaxurl, objectToFormData(data)).then(function (results) {
            return results.data;
          })["catch"](function (error) {
            return error;
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchAllEvents.apply(this, arguments);
}
export function fetchAllLocations() {
  return _fetchAllLocations.apply(this, arguments);
}
function _fetchAllLocations() {
  _fetchAllLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          data = {
            action: 'do_ajax',
            fn: 'get_all_locations',
            dataType: 'json'
          };
          return _context2.abrupt("return", axios.post(ajaxurl, objectToFormData(data)).then(function (results) {
            return results.data;
          })["catch"](function (error) {
            return error;
          }));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchAllLocations.apply(this, arguments);
}
export function fetchEventContent(_x, _x2) {
  return _fetchEventContent.apply(this, arguments);
}
function _fetchEventContent() {
  _fetchEventContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(slug, intro) {
    var data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = {
            action: 'do_ajax',
            fn: 'get_event_by_slug',
            dataType: 'json',
            event: slug,
            intro: intro
          };
          return _context3.abrupt("return", axios.post(ajaxurl, objectToFormData(data)).then(function (results) {
            if (!results.data) {
              return;
            }
            return results.data;
          })["catch"](function (error) {
            return console.error(error);
          }));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchEventContent.apply(this, arguments);
}
export function fetchEventContentById(slug) {
  var data = {
    action: 'do_ajax',
    fn: 'get_event_content_by_handle',
    dataType: 'json',
    event: slug
  };
  return axios.post(ajaxurl, objectToFormData(data)).then(function (results) {
    if (!results.data) {
      return;
    }
    return results.data;
  })["catch"](function (error) {
    return console.error(error);
  });
}
export function parseTime(t) {
  var d = '';
  var time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/);
  d += parseInt(time[1]) + (time[3] ? 12 : '00');
  d += ':';
  d += parseInt(time[2]) || '00';
  d += ':00';
  return d;
}
export function beautyTime(t) {
  var express = /^(((([0-1][0-9])|(2[0-3])):?[0-5][0-9]:?[0-5][0-9]+$))/;
  if (express.test(t)) {
    var hour = Number(t.split(":")[0]);
    var minute = t.split(":")[1];
    var type = 'PM';
    if (hour > 11) {
      if (hour > 12) {
        hour = hour - 12;
      }
      if (hour == 24) {
        hour = 12;
      }
    } else {
      type = 'AM';
    }
    if (hour == 0) {
      hour = 12;
    }
    return (hour < 10 ? "".concat(hour) : hour) + ":" + minute + " " + type;
  } else {
    return '1:00 AM';
  }
}
export function alphabetically(a, b) {
  // Use toUpperCase() to ignore character casing
  var eventA = a.title.toUpperCase();
  var eventB = b.title.toUpperCase();
  var comparison = 0;
  if (eventA > eventB) {
    comparison = 1;
  } else if (eventA < eventB) {
    comparison = -1;
  }
  return comparison;
}
export function by_start_time(a, b) {
  // Use toUpperCase() to ignore character casing
  var eventA = a.start_time ? moment(a.start_time, ["h:mm A"]).format("HH:mm:ss") : moment('23:59:59', ["h:mm A"]).format("HH:mm:ss");
  var eventB = b.start_time ? moment(b.start_time, ["h:mm A"]).format("HH:mm:ss") : moment('23:59:59', ["h:mm A"]).format("HH:mm:ss");
  if (a.intro || b.intro) return 1;
  var comparison = 0;
  if (eventA > eventB) {
    comparison = 1;
  } else if (eventA < eventB) {
    comparison = -1;
  }
  return comparison;
}
export function by_start_date_time(a, b) {
  var eventAStartDate = a.date ? a.date : a.start_date;
  var eventBStartDate = b.date ? b.date : b.start_date;
  var eventAStartTime = a.dates ? a.dates[0].start_time : a.start_time;
  var eventBStartTime = b.dates ? b.dates[0].start_time : b.start_time;
  if (a.dates) {
    eventAStartDate = a.dates[0].event_date;
    eventAStartTime = a.dates[0].start_time;
  }
  if (b.dates) {
    eventBStartDate = b.dates[0].event_date;
    eventBStartTime = b.dates[0].start_time;
  }
  var eventADateStringStart = "".concat(eventAStartDate, " ").concat(eventAStartTime ? moment(eventAStartTime, ["h:mm A"]).format("HH:mm:ss") : moment(eventAStartDate + 'T06:00:00', ["h:mm A"]).format("HH:mm:ss"));
  var eventBDateStringStart = "".concat(eventBStartDate, " ").concat(eventBStartTime ? moment(eventBStartTime, ["h:mm A"]).format("HH:mm:ss") : moment(eventBStartDate + 'T06:00:00', ["h:mm A"]).format("HH:mm:ss"));
  var eventATimeStart = new Date(eventADateStringStart.replace(/-/g, "/")).getTime();
  var eventBTimeStart = new Date(eventBDateStringStart.replace(/-/g, "/")).getTime();
  var eventAEndDate = a.end_date ? a.end_date : a.date;
  var eventBEndDate = b.end_date ? b.end_date : b.date;
  if (a.dates && a.dates.length > 1) {
    eventAEndDate = a.dates[a.dates.length - 1].event_date;
  }
  if (b.dates && b.dates.length > 1) {
    eventBEndDate = b.dates[b.dates.length - 1].event_date;
  }
  var eventAEndTime = a.dates ? a.dates[0].end_time : a.end_time;
  var eventBEndTime = b.dates ? b.dates[0].end_time : b.end_time;
  var eventADateStringEnd = "".concat(eventAEndDate, " ").concat(eventAEndTime ? moment(eventAEndTime, ["h:mm A"]).format("HH:mm:ss") : false);
  var eventBDateStringEnd = "".concat(eventBEndDate, " ").concat(eventBEndTime ? moment(eventBEndTime, ["h:mm A"]).format("HH:mm:ss") : false);
  var eventATimeEnd = new Date(eventADateStringEnd.replace(/-/g, "/")).getTime();
  var eventBTimeEnd = new Date(eventBDateStringEnd.replace(/-/g, "/")).getTime();
  var comparison = 0;
  if (eventAStartDate && eventBStartDate) {
    if (new Date(eventAStartDate).getDay() < new Date(eventBStartDate).getDay()) {
      comparison = -1;
    }
    if (new Date(eventAStartDate).getDay() > new Date(eventBStartDate).getDay()) {
      comparison = 1;
    }
  }
  if (comparison === 0 && eventAEndDate && eventBEndDate) {
    if (new Date(eventAEndDate).getDay() < new Date(eventBEndDate).getDay()) {
      comparison = -1;
    }
    if (new Date(eventAEndDate).getDay() > new Date(eventBEndDate).getDay()) {
      comparison = 1;
    }
  }
  if (comparison === 0 && eventATimeStart && eventBTimeStart) {
    if (eventATimeStart < eventBTimeStart) {
      comparison = -1;
    }
    if (eventATimeStart > eventBTimeStart) {
      comparison = 1;
    }
  }
  if (comparison === 0 && eventATimeEnd && eventBTimeEnd) {
    if (eventATimeEnd < eventBTimeEnd) {
      comparison = -1;
    }
    if (eventATimeEnd > eventBTimeEnd) {
      comparison = 1;
    }
  }
  return comparison;
}
export function by_end_date_time(a, b) {
  var eventAEndDate = a.end_date ? a.end_date : a.date;
  var eventBEndDate = b.end_date ? b.end_date : b.date;
  if (a.dates) {
    eventAEndDate = a.dates[a.dates.length - 1].event_date;
  }
  if (b.dates) {
    eventBEndDate = b.dates[b.dates.length - 1].event_date;
  }
  var comparison = 0;
  if (eventAEndDate > eventBEndDate) {
    comparison = 1;
  } else if (eventAEndDate < eventBEndDate) {
    comparison = -1;
  }
  return comparison;
}
export var moveElementToEndOfArray = function moveElementToEndOfArray(arr, x) {
  // Array is [1, 2, 3, 4, 5] and x = 2
  // final output would be [3, 4, 5, 1, 2]
  var eventToMove = arr[x];
  var newArray = arr.filter(function (item, index) {
    return index !== x;
  });

  // After this loop array will 
  // be [1, 2, 3, 4, 5, 1, 2]
  newArray.push(eventToMove);

  // Splice method will remove first
  // x = 2 elements from the array
  // so array will be [3, 4, 5, 1, 2]

  return newArray;
};
export var moveElementToStartOfArray = function moveElementToStartOfArray(arr, x) {
  // Array is [1, 2, 3, 4, 5] and x = 2
  // final output would be [3, 4, 5, 1, 2]
  var eventToMove = arr[x];
  var newArray = arr.filter(function (item, index) {
    return index !== x;
  });

  // After this loop array will 
  // be [1, 2, 3, 4, 5, 1, 2]
  newArray.unshift(eventToMove);

  // Splice method will remove first
  // x = 2 elements from the array
  // so array will be [3, 4, 5, 1, 2]

  return newArray;
};
export var getFormattedTime = function getFormattedTime() {
  var datetime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var date = new Date();
  if (datetime) {
    date = datetime;
  }
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  var paddedMinutes = minutes.toString().padStart(2, '0');
  return "".concat(hours, ":").concat(paddedMinutes).concat(ampm);
};